import { graphql } from 'gatsby';
import React from 'react';
import { ModuleBgColor } from '../templates/Page';
import AccordionModule, {
  AccordionModuleProps,
  getModuleBgColor as getAccordionModuleBgColor,
} from './ui/modules/AccordionModule';
import AlternativeFundAssetCarouselModule, {
  AlternativeFundAssetCarouselModuleProps,
  getModuleBgColor as getAlternativeFundAssetCarouselModuleBgColor,
} from './ui/modules/AlternativeFundAssetCarouselModule';
import CTAModule, {
  CTAModuleProps,
  getModuleBgColor as getCtaModuleBgColor,
} from './ui/modules/CTAModule';
import CircularTextGridModule, {
  CircularTextGridModuleProps,
  getModuleBgColor as getCircularTextGridModuleBgColor,
} from './ui/modules/CircularTextGridModule';
import ContactsModule, {
  ContactsModuleProps,
  getModuleBgColor as getContactsModuleBgColor,
} from './ui/modules/ContactsModule';
import DocumentsModule, {
  DocumentsModuleProps,
  getModuleBgColor as getDocumentsModuleBgColor,
} from './ui/modules/DocumentsModule';
import FeaturedInModule, {
  FeaturedInModuleProps,
  getModuleBgColor as getFeaturedInModuleBgColor,
} from './ui/modules/FeaturedInModule';
import FundsModule, {
  FundsModuleProps,
  getModuleBgColor as getFundsModuleBgColor,
} from './ui/modules/FundsModule';
import ImageWithBranchingInfoModule, {
  ImageWithBranchingInfoModuleProps,
  getModuleBgColor as getImageWithBranchingInfoModuleBgColor,
} from './ui/modules/ImageWithBranchingInfoModule';

import ItemGridModule, {
  ItemGridModuleProps,
  getModuleBgColor as getItemGridModuleBgColor,
} from './ui/modules/ItemGridModule';

import LatestInsightsModule, {
  LatestInsightsModuleProps,
  getModuleBgColor as getLatestInsightsModuleBgColor,
} from './ui/modules/LatestInsightsModule';

import OrganizationalChartModule, {
  OrganizationalChartModuleProps,
  getModuleBgColor as getOrganizationalChartModuleBgColor,
} from './ui/modules/OrganizationalChartModule';
import TeamModule, {
  TeamModuleProps,
  getModuleBgColor as getTeamModuleBgColor,
} from './ui/modules/TeamModule';
import TextAndImageModule, {
  TextAndImageModuleProps,
  getModuleBgColor as getTextAndImageModuleBgColor,
} from './ui/modules/TextAndImageModule';
import TextBlocksModule, {
  TextBlocksModuleProps,
  getModuleBgColor as getTextBlocksModuleBgColor,
} from './ui/modules/TextBlocksModule';
import TextWithBackgroundImageModule, {
  TextWithBackgroundImageModuleProps,
  getModuleBgColor as getTextWithBackgroundImageModuleBgColor,
} from './ui/modules/TextWithBackgroundImageModule';
import VideoModule, {
  VideoModuleProps,
  getModuleBgColor as getVideoModuleBgColor,
} from './ui/modules/VideoModule';

export const ModulesFragment = graphql`
  fragment Modules on SanityPageAccordionModuleOrPageAlternativeFundAssetCarouselModuleOrPageCircularTextGridModuleOrPageContactsModuleOrPageCtaModuleOrPageDocumentsModuleOrPageFeaturedInModuleOrPageFundsModuleOrPageImageWithBranchingInfoModuleOrPageItemGridModuleOrPageLatestInsightsModuleOrPageOrganizationalChartModuleOrPageTeamModuleOrPageTextAndImageModuleOrPageTextBlocksModuleOrPageTextWithBackgroundImageModuleOrPageVideoModule {
    __typename
    ...AccordionModule
    ... on SanityPageAccordionModule {
      moduleId
      disabled
    }
    ...AlternativeFundAssetCarouselModule
    ... on SanityPageAlternativeFundAssetCarouselModule {
      moduleId
      disabled
    }
    ...CircularTextGridModule
    ... on SanityPageCircularTextGridModule {
      moduleId
      disabled
    }
    ...ContactsModule
    ... on SanityPageContactsModule {
      moduleId
      disabled
    }
    ...CTAModule
    ... on SanityPageCtaModule {
      moduleId
      disabled
    }
    ...DocumentsModule
    ... on SanityPageDocumentsModule {
      moduleId
      disabled
    }
    ...FeaturedInModule
    ... on SanityPageFeaturedInModule {
      moduleId
      disabled
    }
    ...LatestInsightsModule
    ... on SanityPageLatestInsightsModule {
      moduleId
      disabled
    }
    ...FundsModule
    ... on SanityPageFundsModule {
      moduleId
      disabled
    }
    ...ImageWithBranchingInfoModule
    ... on SanityPageImageWithBranchingInfoModule {
      moduleId
      disabled
    }
    ...ItemGridModule
    ... on SanityPageItemGridModule {
      moduleId
      disabled
    }
    ...OrganizationalChartModule
    ... on SanityPageOrganizationalChartModule {
      moduleId
      disabled
    }
    ...TeamModule
    ... on SanityPageTeamModule {
      moduleId
      disabled
    }
    ...TextAndImageModule
    ... on SanityPageTextAndImageModule {
      moduleId
      disabled
    }
    ...TextBlocksModule
    ... on SanityPageTextBlocksModule {
      moduleId
      disabled
    }
    ...TextWithBackgroundImageModule
    ... on SanityPageTextWithBackgroundImageModule {
      moduleId
      disabled
    }
    ...VideoModule
    ... on SanityPageVideoModule {
      moduleId
      disabled
    }
  }
`;

export interface ModulesContentProps {
  modules: Array<Module>;
  calendlyLink: string;
}

export interface CommonModuleProps {
  moduleId?: string;
  disabled?: boolean | null;
  previousModuleBgColor?: ModuleBgColor;
}

export type Module =
  | (AccordionModuleProps & CommonModuleProps & { __typename: 'SanityPageAccordionModule' })
  | (AlternativeFundAssetCarouselModuleProps &
      CommonModuleProps & { __typename: 'SanityPageAlternativeFundAssetCarouselModule' })
  | (CircularTextGridModuleProps &
      CommonModuleProps & { __typename: 'SanityPageCircularTextGridModule' })
  | (ContactsModuleProps & CommonModuleProps & { __typename: 'SanityPageContactsModule' })
  | (CTAModuleProps & CommonModuleProps & { __typename: 'SanityPageCtaModule' })
  | (DocumentsModuleProps & CommonModuleProps & { __typename: 'SanityPageDocumentsModule' })
  | (FeaturedInModuleProps & CommonModuleProps & { __typename: 'SanityPageFeaturedInModule' })
  | (LatestInsightsModuleProps &
      CommonModuleProps & { __typename: 'SanityPageLatestInsightsModule' })
  | (FundsModuleProps & CommonModuleProps & { __typename: 'SanityPageFundsModule' })
  | (ImageWithBranchingInfoModuleProps &
      CommonModuleProps & { __typename: 'SanityPageImageWithBranchingInfoModule' })
  | (ItemGridModuleProps & CommonModuleProps & { __typename: 'SanityPageItemGridModule' })
  | (OrganizationalChartModuleProps &
      CommonModuleProps & { __typename: 'SanityPageOrganizationalChartModule' })
  | (TeamModuleProps & CommonModuleProps & { __typename: 'SanityPageTeamModule' })
  | (TextAndImageModuleProps & CommonModuleProps & { __typename: 'SanityPageTextAndImageModule' })
  | (TextBlocksModuleProps & CommonModuleProps & { __typename: 'SanityPageTextBlocksModule' })
  | (TextWithBackgroundImageModuleProps &
      CommonModuleProps & { __typename: 'SanityPageTextWithBackgroundImageModule' })
  | (VideoModuleProps & CommonModuleProps & { __typename: 'SanityPageVideoModule' });

function ModulesContent({ modules, calendlyLink }: ModulesContentProps): React.ReactElement {
  const enabledModules = modules.filter(module => !module.disabled);

  return (
    <>
      {enabledModules.map((module, moduleIndex) => {
        const moduleKey = 'module-' + moduleIndex;

        let previousModuleBgColor: ModuleBgColor = 'colored';
        if (moduleIndex > 0) {
          const previousModule = enabledModules[moduleIndex - 1];
          if (previousModule.__typename === 'SanityPageAccordionModule') {
            previousModuleBgColor = getAccordionModuleBgColor(previousModule);
          } else if (previousModule.__typename === 'SanityPageAlternativeFundAssetCarouselModule') {
            previousModuleBgColor = getAlternativeFundAssetCarouselModuleBgColor(previousModule);
          } else if (previousModule.__typename === 'SanityPageCircularTextGridModule') {
            previousModuleBgColor = getCircularTextGridModuleBgColor(previousModule);
          } else if (previousModule.__typename === 'SanityPageContactsModule') {
            previousModuleBgColor = getContactsModuleBgColor(previousModule);
          } else if (previousModule.__typename === 'SanityPageCtaModule') {
            previousModuleBgColor = getCtaModuleBgColor(previousModule);
          } else if (previousModule.__typename === 'SanityPageDocumentsModule') {
            previousModuleBgColor = getDocumentsModuleBgColor(previousModule);
          } else if (previousModule.__typename === 'SanityPageFeaturedInModule') {
            previousModuleBgColor = getFeaturedInModuleBgColor(previousModule);
          } else if (previousModule.__typename === 'SanityPageFundsModule') {
            previousModuleBgColor = getFundsModuleBgColor(previousModule);
          } else if (previousModule.__typename === 'SanityPageLatestInsightsModule') {
            previousModuleBgColor = getLatestInsightsModuleBgColor(previousModule);
          } else if (previousModule.__typename === 'SanityPageImageWithBranchingInfoModule') {
            previousModuleBgColor = getImageWithBranchingInfoModuleBgColor(previousModule);
          } else if (previousModule.__typename === 'SanityPageItemGridModule') {
            previousModuleBgColor = getItemGridModuleBgColor(previousModule);
          } else if (previousModule.__typename === 'SanityPageOrganizationalChartModule') {
            previousModuleBgColor = getOrganizationalChartModuleBgColor(previousModule);
          } else if (previousModule.__typename === 'SanityPageTeamModule') {
            previousModuleBgColor = getTeamModuleBgColor(previousModule);
          } else if (previousModule.__typename === 'SanityPageTextAndImageModule') {
            previousModuleBgColor = getTextAndImageModuleBgColor(previousModule);
          } else if (previousModule.__typename === 'SanityPageTextBlocksModule') {
            previousModuleBgColor = getTextBlocksModuleBgColor(previousModule);
          } else if (previousModule.__typename === 'SanityPageTextWithBackgroundImageModule') {
            previousModuleBgColor = getTextWithBackgroundImageModuleBgColor(previousModule);
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          } else if (previousModule.__typename === 'SanityPageVideoModule') {
            previousModuleBgColor = getVideoModuleBgColor(previousModule);
          } else {
            throw new Error(
              // @ts-expect-error
              'Got unexpected previousModule with typename ' + previousModule.__typename,
            );
          }
        }

        const commonModuleProps: CommonModuleProps = {
          previousModuleBgColor,
        };

        if (module.__typename === 'SanityPageAccordionModule') {
          return (
            <AccordionModule
              key={moduleKey}
              {...commonModuleProps}
              {...module}
            ></AccordionModule>
          );
        }

        if (module.__typename === 'SanityPageAlternativeFundAssetCarouselModule') {
          return (
            <AlternativeFundAssetCarouselModule
              key={moduleKey}
              {...commonModuleProps}
              {...module}
            ></AlternativeFundAssetCarouselModule>
          );
        }

        if (module.__typename === 'SanityPageCircularTextGridModule') {
          return (
            <CircularTextGridModule
              key={moduleKey}
              {...commonModuleProps}
              {...module}
            ></CircularTextGridModule>
          );
        }

        if (module.__typename === 'SanityPageContactsModule') {
          return (
            <ContactsModule key={moduleKey} {...commonModuleProps} {...module}></ContactsModule>
          );
        }

        if (module.__typename === 'SanityPageCtaModule') {
          return (
            <CTAModule
              key={moduleKey}
              {...commonModuleProps}
              {...module}
              calendlyLink={calendlyLink}
            ></CTAModule>
          );
        }

        if (module.__typename === 'SanityPageDocumentsModule') {
          return (
            <DocumentsModule key={moduleKey} {...commonModuleProps} {...module}></DocumentsModule>
          );
        }

        if (module.__typename === 'SanityPageFeaturedInModule') {
          return (
            <FeaturedInModule key={moduleKey} {...commonModuleProps} {...module}></FeaturedInModule>
          );
        }

        if (module.__typename === 'SanityPageLatestInsightsModule') {
          return (
            <LatestInsightsModule
              key={moduleKey}
              {...commonModuleProps}
              {...module}
            ></LatestInsightsModule>
          );
        }

        if (module.__typename === 'SanityPageFundsModule') {
          return <FundsModule key={moduleKey} {...commonModuleProps} {...module}></FundsModule>;
        }

        if (module.__typename === 'SanityPageImageWithBranchingInfoModule') {
          return (
            <ImageWithBranchingInfoModule
              key={moduleKey}
              {...commonModuleProps}
              {...module}
            ></ImageWithBranchingInfoModule>
          );
        }

        if (module.__typename === 'SanityPageItemGridModule') {
          return (
            <ItemGridModule key={moduleKey} {...commonModuleProps} {...module}></ItemGridModule>
          );
        }

        if (module.__typename === 'SanityPageOrganizationalChartModule') {
          return (
            <OrganizationalChartModule
              key={moduleKey}
              {...commonModuleProps}
              {...module}
            ></OrganizationalChartModule>
          );
        }

        if (module.__typename === 'SanityPageTeamModule') {
          return <TeamModule key={moduleKey} {...commonModuleProps} {...module}></TeamModule>;
        }

        if (module.__typename === 'SanityPageTextAndImageModule') {
          return (
            <TextAndImageModule
              key={moduleKey}
              {...commonModuleProps}
              {...module}
            ></TextAndImageModule>
          );
        }

        if (module.__typename === 'SanityPageTextBlocksModule') {
          return (
            <TextBlocksModule key={moduleKey} {...commonModuleProps} {...module}></TextBlocksModule>
          );
        }

        if (module.__typename === 'SanityPageTextWithBackgroundImageModule') {
          return (
            <TextWithBackgroundImageModule
              key={moduleKey}
              {...commonModuleProps}
              {...module}
            ></TextWithBackgroundImageModule>
          );
        }

        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (module.__typename === 'SanityPageVideoModule') {
          return <VideoModule key={moduleKey} {...commonModuleProps} {...module}></VideoModule>;
        }

        // @ts-expect-error
        throw new Error('Got unexpected typename: ' + module.__typename);
      })}
    </>
  );
}

export default ModulesContent;
